module.exports = __webpack_public_path__ + "h5/img/foods.b4c417a5.jpg";